import { render, staticRenderFns } from "./BioPanel.vue?vue&type=template&id=0fa1edb0"
import script from "./BioPanel.vue?vue&type=script&lang=js"
export * from "./BioPanel.vue?vue&type=script&lang=js"
import style0 from "./BioPanel.vue?vue&type=style&index=0&id=0fa1edb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports